import { replaceKinstaImageUrl } from './replaceKinstImageUrl';

import type { StrapiEstate, LayoutImage } from '@monoimin/sb-types';

/**
 * Подготовка изображений объекта недвижимости (multiple image field) для использования.
 *
 * @param estate - Данные объекта недвижимости.
 * @returns Массив подготовленных для использования в изображениях объектов.
 */
export const pickImagesFromEstate = (estate?: StrapiEstate): LayoutImage[] => {
  if (!estate) {
    return [];
  }

  const { title, images } = estate;

  if (images) {
    return images.reduce<LayoutImage[]>((acc, item, currentIndex) => {
      if (item.url) {
        return [
          ...acc,
          {
            src: replaceKinstaImageUrl(item.url),
            alt: title + ` ${currentIndex + 1}`,
            priority: !currentIndex,
          },
        ];
      }

      return acc;
    }, []);
  }

  return [];
};

export default pickImagesFromEstate;
